import { r as registerInstance, c as createEvent, h } from './index-5faac9d7.js';
import { c as classnames } from './index-5d9a618b.js';
import './_commonjsHelpers-11ca3be1.js';

const getQuestionnaireItemByPath = (childItems, path, index = 0) => {
  var _a;
  const lastIndex = path.length - 1;
  let questionnaireItem = childItems.find((item) => item.answer === path[index]);
  if (!!((_a = questionnaireItem === null || questionnaireItem === void 0 ? void 0 : questionnaireItem.childItems) === null || _a === void 0 ? void 0 : _a.length) && lastIndex !== index) {
    questionnaireItem = getQuestionnaireItemByPath(questionnaireItem.childItems, path, index + 1);
  }
  return questionnaireItem;
};
const generatePath = (selectedItem, selectedChild, isLastSelected) => {
  var _a;
  if (!((_a = selectedItem.path) === null || _a === void 0 ? void 0 : _a.length)) {
    return [selectedChild.answer];
  }
  const { path } = selectedItem;
  const pathToParent = path.slice(0, path.length - 1);
  return isLastSelected && (pathToParent === null || pathToParent === void 0 ? void 0 : pathToParent.length) !== 0
    ? [...pathToParent, selectedChild.answer]
    : [...path, selectedChild.answer];
};
function isSelectedItem(item) {
  return 'answer' in item && 'question' in item && 'childItems' in item && 'rangeIds' in item;
}
const createSelectedItem = (item, path) => ({
  answer: item.answer,
  childItems: item.childItems,
  question: item.question,
  rangeIds: isSelectedItem(item) ? item.rangeIds : [],
  path,
});

const widgetBodyCss = ".widget-body{display:flex;flex-direction:column;position:relative;height:100%}.widget-body__question{display:flex;justify-content:center;align-items:center;flex-direction:column;padding-bottom:16px;width:100%}@media screen and (min-width: 980px){.widget-body__question{border-bottom:1px solid #e7e6e6}}.widget-body__question--first{border:none}@media screen and (min-width: 980px){.widget-body__question--first{height:100%}}.widget-body__back-button{visibility:hidden}.widget-body__back-button--visible{visibility:visible}";

const WidgetBody = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.didDisplayRanges = createEvent(this, "didDisplayRanges", 7);
    this.data = undefined;
    this.rangeTooltipInfo = undefined;
    this.selectorConfig = undefined;
    this.isMobile = undefined;
    this.isPBS = false;
    this.currentSelected = undefined;
    this.previousSelected = undefined;
    this.isLastSelected = false;
    this.question = undefined;
    this.answers = undefined;
    this.ranges = undefined;
    this.breadcrumbs = [];
  }
  onItemSelect(event) {
    var _a, _b, _c, _d;
    const value = event.detail;
    const selectedChild = this.isLastSelected
      ? (_b = (_a = this.previousSelected) === null || _a === void 0 ? void 0 : _a.childItems) === null || _b === void 0 ? void 0 : _b.find((item) => item.answer === value)
      : (_d = (_c = this.currentSelected) === null || _c === void 0 ? void 0 : _c.childItems) === null || _d === void 0 ? void 0 : _d.find((item) => item.answer === value);
    if (selectedChild) {
      const path = generatePath(this.currentSelected, selectedChild, this.isLastSelected);
      this.currentSelected = createSelectedItem(selectedChild, path);
    }
  }
  onBreadcrumbClicked(e) {
    const { path } = e.detail;
    if (path === null || path === void 0 ? void 0 : path.length) {
      this.currentSelected = this.getParentItemByPath(path);
    }
  }
  onBackButtonClick() {
    const { path } = this.currentSelected;
    if (path === null || path === void 0 ? void 0 : path.length) {
      this.currentSelected = this.getParentItemByPath(path);
    }
  }
  onSelectedChange() {
    this.setIsLastSelected();
    this.getPreviousSelected();
    this.getCurrentQuestion();
    this.getCurrentAnswers();
    this.filterRanges();
    this.createBreadcrumbs();
  }
  onRangesDisplay() {
    var _a;
    if ((_a = this.ranges) === null || _a === void 0 ? void 0 : _a.length) {
      const rangesIds = this.ranges.map((range) => range.rangeId);
      this.didDisplayRanges.emit(rangesIds);
    }
  }
  getParentItemByPath(path) {
    const pathToParent = path.slice(0, path.length - 1);
    const questionnaireItem = getQuestionnaireItemByPath(this.data.questionnaire.questionnaireItem.childItems, pathToParent);
    if (questionnaireItem) {
      return createSelectedItem(questionnaireItem, pathToParent);
    }
    return createSelectedItem(this.data.questionnaire.questionnaireItem);
  }
  getCurrentAnswers() {
    this.answers = this.isLastSelected
      ? this.previousSelected.childItems.map((i) => i.answer)
      : this.currentSelected.childItems.map((i) => i.answer);
  }
  getCurrentQuestion() {
    this.question = this.isLastSelected
      ? this.previousSelected.question
      : this.currentSelected.question;
  }
  getPreviousSelected() {
    const { path } = this.currentSelected;
    if (path === null || path === void 0 ? void 0 : path.length) {
      this.previousSelected = this.getParentItemByPath(path);
    }
  }
  filterRanges() {
    var _a, _b;
    const rangeIds = (_a = this.currentSelected) === null || _a === void 0 ? void 0 : _a.rangeIds;
    const filteredRanges = (_b = this.data.ranges) === null || _b === void 0 ? void 0 : _b.filter((range) => {
      return rangeIds === null || rangeIds === void 0 ? void 0 : rangeIds.includes(range.rangeId);
    });
    this.ranges = filteredRanges === null || filteredRanges === void 0 ? void 0 : filteredRanges.sort((range1, range2) => {
      const rangeId1 = range1.rangeId;
      const rangeId2 = range2.rangeId;
      return rangeIds.indexOf(rangeId1) - rangeIds.indexOf(rangeId2);
    });
  }
  setIsLastSelected() {
    this.isLastSelected = !this.currentSelected.childItems.length;
  }
  createBreadcrumbs() {
    var _a, _b, _c;
    if ((_a = this.currentSelected) === null || _a === void 0 ? void 0 : _a.path) {
      let newPath;
      this.breadcrumbs = (_c = (_b = this.currentSelected) === null || _b === void 0 ? void 0 : _b.path) === null || _c === void 0 ? void 0 : _c.map((selected) => {
        newPath = newPath ? [...newPath, selected] : [selected];
        return {
          name: selected,
          path: newPath,
        };
      });
    }
    else {
      this.breadcrumbs = [];
    }
  }
  componentWillLoad() {
    const { questionnaireItem } = this.data.questionnaire;
    this.currentSelected = createSelectedItem(questionnaireItem);
  }
  render() {
    var _a, _b;
    const isFirstQuestion = !this.currentSelected.path;
    return (h("div", { class: "widget-body" }, this.isMobile ? (h("pes-widget-back-button", { backLabel: (_a = this.data.labels) === null || _a === void 0 ? void 0 : _a.backLabel, class: classnames('widget-body__back-button', {
        'widget-body__back-button--visible': this.currentSelected.path,
      }) })) : (h("pes-widget-breadcrumbs", { breadcrumbs: this.breadcrumbs, isLastSelected: this.isLastSelected })), h("div", { class: classnames('widget-body__question', {
        'widget-body__question--first': isFirstQuestion,
      }) }, h("pes-widget-header", { isLarge: isFirstQuestion }, this.question), h("pes-widget-answers", { answers: this.answers, selectedAnswer: this.currentSelected.answer })), ((_b = this.ranges) === null || _b === void 0 ? void 0 : _b.length) !== 0 && (h("pes-widget-ranges", { ranges: this.ranges, rangeTooltipInfo: this.rangeTooltipInfo, isMobile: this.isMobile, isPBS: this.isPBS, isLastSelected: this.isLastSelected, labels: this.data.labels, selectorConfig: this.selectorConfig }))));
  }
  static get watchers() { return {
    "currentSelected": ["onSelectedChange"],
    "ranges": ["onRangesDisplay"]
  }; }
};
WidgetBody.style = widgetBodyCss;

export { WidgetBody as pes_widget_body };
